// external
import React, { useState, useContext } from "react";
import { useLocation } from "react-router-dom";

// components
import CustomButton from "components/partials/custom-button/custom-button";
import FeedbackForm from "components/partials/feedback-form/feedback-form";

// state managing/security
import { FeedbackContext } from "context/FeedbackContext";

// assets
import Icons from "assets/icons";

function FaoBuilderFeedback() {
  const [isFeedbackFormVisible, setIsFeedbackFormVisible] = useState(false);
  const { submitFeedback } = useContext(FeedbackContext);
  const location = useLocation();
  const handleFeedbackSubmit = (feedbackType, feedbackText, onComplete) => {
    submitFeedback(
      feedbackType,
      feedbackText,
      `{location: ${location.pathname} ,button: Fao Builder Feedback}`
    ).finally(onComplete);
  };
  return (
    <div>
      {isFeedbackFormVisible && (
        <FeedbackForm
          onClose={() => setIsFeedbackFormVisible(false)}
          onSubmit={handleFeedbackSubmit}
          verticalPosition="below"
        />
      )}
      <CustomButton
        variant="primary"
        size="md"
        iconBefore={
          <Icons.Info aria-label="Feedback" height="100%" width="20" />
        }
        onClick={() => setIsFeedbackFormVisible(true)}
      >
        Thoughts?
      </CustomButton>
    </div>
  );
}

export default FaoBuilderFeedback;
